package com.rainbowclubs.rainbow.data.requests

import kotlinx.serialization.Serializable

@Serializable
data class CreateEventRequest(
    val clubId: String,
    val startsAt: Long,
    val endsAt: Long,
    val description: String,
    val title: String,
    val location: String? = null,
)
